import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16a93494"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "agreement-message" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "agreement-message--first-line" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "agreement-message__state" }, " 서비스 이용약관에")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "agreement-message--second-line" }, "동의해 주세요")
], -1 /* HOISTED */))
const _hoisted_3 = { class: "check-all" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider",
  role: "separator",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "agreement-wrapper" }
const _hoisted_6 = ["onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "이용약관" }),
        _createElementVNode("main", null, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["CheckboxInput"], {
              value: $setup.agreeAll,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.agreeAll) = $event)),
              onOnChangedCheck: $setup.onChangedAgreementsAll,
              title: "모두 동의"
            }, null, 8 /* PROPS */, ["value"])
          ]),
          _hoisted_4,
          _createElementVNode("section", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.termsList, (termsInfo, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "agreement-terms",
                key: index
              }, [
                _createVNode($setup["CheckboxInput"], {
                  value: termsInfo.agreeYn,
                  "onUpdate:value": ($event: any) => ((termsInfo.agreeYn) = $event),
                  shouldHideCheckbox: termsInfo.hideCheckboxYn,
                  title: $setup.getTitle(termsInfo)
                }, null, 8 /* PROPS */, ["value", "onUpdate:value", "shouldHideCheckbox", "title"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "agreement-show",
                  onClick: ($event: any) => ($setup.onClickTerms(termsInfo.code)),
                  "aria-label": `${termsInfo.title} 전문 보기`
                }, " 보기 ", 8 /* PROPS */, _hoisted_6)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode($setup["FooterButton"], {
            title: "동의하고 가입하기",
            disabled: !$setup.isActive(),
            onOnClickFooterButton: $setup.handleSignup
          }, null, 8 /* PROPS */, ["disabled"])
        ])
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowTerms,
        onBackHandler: () => $setup.toggleShowTerms(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["TermsDetail"], {
            title: $setup.selectedTerms?.title ?? '',
            url: $setup.selectedTerms?.url ?? '',
            onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowTerms(false)))
          }, null, 8 /* PROPS */, ["title", "url"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}